import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/features/auth';
import { ROUTES } from '@/lib/constants/routes';

interface PermissionGuardProps {
  children: ReactNode;
  resource: string;
  action: string;
  fallback?: ReactNode;
  redirectTo?: string;
}

export function PermissionGuard({
  children,
  resource,
  action,
  fallback,
  redirectTo = ROUTES.FORBIDDEN,
}: PermissionGuardProps) {
  const { hasAccess } = useAuth();

  if (!hasAccess(resource, action)) {
    // Show fallback content if provided
    if (fallback) {
      return <>{fallback}</>;
    }

    // Otherwise redirect
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
